import React from 'react';
import { Outlet } from 'react-router-dom';
import UserSidebar from '../components/layout/UserSidebar';
import UserHeader from '../components/layout/UserHeader';

const UserLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <UserSidebar />
      <div className="flex-1 flex flex-col">
        <UserHeader />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default UserLayout;